import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotPaidService } from '../../services/notPaid.service';
import { ServService } from '../../services/serv.service';
import { BikeService2 } from '../../services/bike2.service';
import { ServModel } from '../../models/serv.model';
import { InvoiceModel } from '../../models/invoice.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MagasinService } from '../../services/magasin.service';

@Component({
  selector: 'my-notPaid',
  template: require('./notPaid.component.html'),
  styles: [require('./notPaid.component.scss')]
})

export class NotPaidComponent implements OnInit, OnDestroy{

  onMagasinChange: Subscription;

  constructor(private magasinService:MagasinService, public notPaidService:NotPaidService, public servService:ServService, public bikeService2:BikeService2, public router:Router) {

  }

  openService(service){
    this.servService.current = this.servService.get(service.privateId);
    this.bikeService2.getAll(service.client.id);
  }

  openInvoice(invoice){
    this.router.navigate(['/invoice', invoice.clientPrivateId, invoice.privateId]);
  }

  ngOnInit(): void {
    //this.notPaidService.getAll();
    this.onMagasinChange = this.magasinService.onChangeMagasin.subscribe((_magasin) => {
      this.notPaidService.getAll();
    })
  }

  ngOnDestroy(): void {
    this.onMagasinChange.unsubscribe();
  }

  refresh(){
    this.notPaidService.getAll();
  }

  diffDate(date1:Date, date2:Date = null): number{
    if (!date2)
      date2 = new Date();
    let timeDiff = Math.abs(date2.getTime() - date1.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays - 1;
  }

  calculeWidthBar(day:number, maxDay:number, maxWidth:number){
    let width = 15;
    width += maxWidth / maxDay * day;
    if (width > maxWidth)
      width = 100;
    return width + "%";
  }

  isService(e:ServModel) : boolean{
    return (e instanceof ServModel);
  }

  isInvoice(e) : boolean {
    return (e instanceof InvoiceModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/notPaid/notPaid.component.ts